import React from 'react';
export function Footer() {
  return <footer className="bg-[#2D3748] text-[#F5F1ED] py-16 border-t border-[#F5F1ED]/10" data-id="element-67">
      <div className="max-w-7xl mx-auto px-6" data-id="element-68">
        <div className="flex flex-col md:flex-row justify-between items-center gap-10 md:gap-0" data-id="element-69">
          {/* LEFT: Logo */}
          <div className="w-full md:w-1/3 flex justify-center md:justify-start" data-id="element-70">
            <img src="https://cdn.magicpatterns.com/uploads/67mhm3gdm5ArjTvrn96suP/Large_White_Logo_(Transparent).png" alt="Grounded Mornings" className="h-44 w-auto object-contain" data-id="element-71" />
          </div>

          {/* CENTER: Slogan & Copyright */}
          <div className="w-full md:w-1/3 flex flex-col items-center justify-center text-center" data-id="element-72">
            <p className="text-xl font-serif italic text-[#F5F1ED]/80 mb-3" data-id="element-73">
              Intention on every plate.
            </p>
            <p className="text-xs text-[#F5F1ED]/40 tracking-wider" data-id="element-74">
              © {new Date().getFullYear()} Grounded Mornings
            </p>
          </div>

          {/* RIGHT: Social Links */}
          <div className="w-full md:w-1/3 flex justify-center md:justify-end gap-8 text-sm text-[#F5F1ED]/80" data-id="element-75">
            <a href="#" className="hover:text-white transition-colors" data-id="element-76">
              Instagram
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-77">
              LinkedIn
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-78">
              Email
            </a>
          </div>
        </div>
      </div>
    </footer>;
}